module.exports = __webpack_public_path__ + "img/main3.07143d9.svg";